import React from 'react';
import './Modal.scss';
import cls from 'classnames';
import { AnimatePresence, m } from 'framer-motion';
type ModalProps = {
  onClose: () => void;
  modalHeader?: React.ReactElement;
  modalBody: React.ReactElement;
  modalId: string;
  modalContentClass?: string;
  position?: string;
  isAnimatedDrawer?: boolean;
  fullwidth?: boolean;
  className?: string;
  blurBackground?: boolean;
};

const ModalContent = ({
  modalHeader,
  modalBody,
  className,
}: {
  modalBody?: React.ReactNode;
  modalHeader?: React.ReactNode;
  className?: string;
}) => (
  <div className={cls('modal-content', className)}>
    {modalHeader && <>{modalHeader}</>}
    {modalBody}
  </div>
);
export const Modal = ({
  onClose,
  modalHeader,
  modalBody,
  modalId,
  position = 'center',
  modalContentClass,
  fullwidth,
  isAnimatedDrawer,
  className,
  blurBackground,
}: ModalProps) => {
  const modalContentClasses = cls('modal-dialog', className, {
    ['modal-dialog-centered']: position === 'center',
    ['modal-align-end']: position === 'bottom',
    ['fullwidth']: fullwidth,
  });
  const content = (
    <ModalContent modalBody={modalBody} modalHeader={modalHeader} className={modalContentClass} />
  );
  return (
    <div className="modal fade show generic-modal" tabIndex={-1} id={modalId}>
      <div
        className={cls('modal-backdrop fade', { ['show']: blurBackground })}
        onClick={onClose}
        data-backdrop="static"
      ></div>
      {isAnimatedDrawer ? (
        <AnimatePresence>
          {/* TODO: fix exit animation */}
          <m.div
            className={modalContentClasses}
            initial={{ y: '100vh' }}
            animate={{ y: 0 }}
            exit={{ y: 0 }}
            key="mobile-drawer"
          >
            {content}
          </m.div>
        </AnimatePresence>
      ) : (
        <div className={modalContentClasses}>{content}</div>
      )}
      <div></div>
    </div>
  );
};
